import { connect } from 'react-redux';
import { RootState } from 'store/configureStore';
import Header from 'screens/Panel/screens/Club/components/Header/Header';

export default connect((state: RootState) => {
  return {
    clubName: state.clubShow.club?.company.name || '',
    clubId: state.clubShow.club?.company.id || '',
    clubUpdatedAt: state.clubShow.club?.company.updatedAt || '',
  };
}, {})(Header);
